import request from '@/utils/request'

const baseUrl = '/fullGift/fullGift'

export function pageFullGift (data) {
  return request({ url: `${baseUrl}/page`, method: 'post', data })
}

export function getFullGift (params) {
  return request({ url: `${baseUrl}/detail`, method: 'get', params })
}

export function addFullGift (data) {
  return request({ url: `${baseUrl}/add`, method: 'post', data })
}

export function updateFullGift (data) {
  return request({ url: `${baseUrl}/edit`, method: 'post', data })
}

export function deleteFullGift (data) {
  return request({ url: `${baseUrl}/delete`, method: 'post', data })
}

export function changeFullGiftStatus (data) {
  return request({ url: `${baseUrl}/status`, method: 'post', data })
}

export function increaseFullGiftStock (data) {
  return request({ url: `${baseUrl}/increaseStock`, method: 'post', data })
}

export function pageFullGiftStock (data) {
  return request({ url: `${baseUrl}/stock/page`, method: 'post', data })
}
